export const PROPAGATION_FRAME_ID = 'session-propagation-frame';